<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar> </template>

    <!-- Set Appbar title-->
    <template #title>
      <v-toolbar-title class="font-weight-bold d-flex">
        App Center
      </v-toolbar-title>
      <v-icon small style="margin-top: -20px">mdi-apps</v-icon>
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <ReportIssueButton />
      <FollowUpActionsMenu />
      <NotificationMenu :notifications="notificationHistory.notifications" />
      <!-- <GlobalNotificationButton /> -->
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader> </template>

    <!-- Use display content-->
    <template #content>
      <router-view />
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import NotificationMenu from '@/modules/shared/components/core/NotificationMenu.vue';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';
import FollowUpActionsMenu from '@/modules/shared/components/follow-up-actions/FollowUpActionsMenu.vue';
import CoreMixin from '@/mixins/core.mixin';
import appLinks from '@/router/data/appLinks.json';
import { mapActions, mapState } from 'vuex';
import SocketMixin from '@/modules/delinquency/mixins/socket.mixin';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,

  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};
export default {
  components: { 
    ApplicationLayout, 
    NotificationMenu, 
    ReportIssueButton,
    FollowUpActionsMenu
  },
  mixins: [CoreMixin, SocketMixin],
  data: () => ({
    options: layoutOptions,
    links: appLinks
  }),

  created() {
    this.loadNotifications({ userId: this.user.id, appName: 'all' });
  },

  computed: {
    ...mapState('userNotificationsModule', ['notificationHistory']),
  },

  methods: {
    ...mapActions('userNotificationsModule', ['loadNotifications']),
  }
};
</script>
